"use strict";

angular
  .module("broadcastsModule")
  .config(function (modalStateProvider) {
    modalStateProvider.state("admin.broadcasters.upload", {
      url: "/upload/{folder_id:[0-9]+}",
      controller: "BroadcastMediaUpload",
      controllerAs: "$ctrl",
      templateUrl: "ng-komondor-media-library/media-upload.html",
      params: { folder_id: 0 },
      resolve: {
        folderId: [
          "modalState",
          function (modalState) {
            return modalState.stateParams.folder_id;
          },
        ],
      },
    });
  });
